import { render, staticRenderFns } from "./Logotype.vue?vue&type=template&id=a306d2d0&"
import script from "./Logotype.vue?vue&type=script&lang=js&"
export * from "./Logotype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports